import { FC, useCallback } from 'react'
import styles from 'components/features/coaching/advisorLandingPage/HowitworksCoachSection/HowitworksCoachSection.styl'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'
import Button from 'components/features/pfm/Button/Button'

type HowitworksCoachSectionProps = {
  onCTA: () => void
}
export const HowitworksCoachSection: FC<HowitworksCoachSectionProps> = (props) => {
  const { onCTA } = props

  const handleCta = useCallback(() => {
    onCTA()
  }, [onCTA])

  return (
    <section className={ styles.howitworksCoachSection }>
      <h2>How It Works</h2>
      <div className={ styles.content }>
        <ul>
          <li>
            <h5>Schedule a video call</h5>
            Tell us what you want to talk about. <br />
            We’ll instantly match you with the right financial professional.
          </li>
          <li>
            <h5>Complete your profile</h5>
            Select a timeslot that works for you. <br />
            We’ll email you the meeting link.
          </li>
          <li>
            <h5>Meet Your Coach</h5>
            Click the meeting link at the scheduled time to video chat with your coach.
          </li>
        </ul>
        <div className={ styles.imageBlock }>
          <img
            className={ styles.image }
            src='/images/homepage/coaching.jpg'
            alt='Unlock professional coaching & more'
            width='100%'
          />
          <AnalyticsClick
            className={ styles.joinBtn }
            category='page_controls-coaching_landing'
            action='click-schedule_cta'
            label='how_it_works_section'
          >
            <Button
              theme='golden'
              shadow='heavy'
              fullHeight
              fullWidth
              onClick={ handleCta }
            >
              SCHEDULE VIDEO CALL
            </Button>
          </AnalyticsClick>
        </div>
      </div>
    </section>
  )
}
